import { Component, EventEmitter, Output, ViewChild } from '@angular/core';
import { EoFormComponent, STATUS } from 'ngx-eo-web-components';
import { filter, Subscription } from 'rxjs';
import { CoreService } from '../../../core/core.service';
import { surgeryUnableToContactFormConfig } from '../../config/surgery-unable-to-contact-form.config';
import { SurgeryPrivateService } from '../../../../services/surgery/surgery.pr.service';
import { Surgery } from '../../../core/models/surgery.model';
import { Validators } from '@angular/forms';
import { Message } from 'primeng/api';

@Component({
  selector: 'app-surgery-unable-to-contact-form-dialog',
  templateUrl: './surgery-unable-to-contact-form-dialog.component.html',
  styleUrls: ['./surgery-unable-to-contact-form-dialog.component.scss'],
})
export class SurgeryUnableToContactFormDialogComponent {
  constructor(
    private surgeryPrivateService: SurgeryPrivateService,
    private coreService: CoreService
  ) {}

  @ViewChild('eoForm', { static: false }) eoForm?: EoFormComponent;
  @Output() success = new EventEmitter();

  messages: Message[] = [];
  subscriptions: Subscription[] = [];
  surgery?: Surgery;
  visible = false;
  formConfig = [...surgeryUnableToContactFormConfig];
  unableToContactComments: string = '';

  ngOnInit(): void {
    this.subscriptions = [this.getSurgeryUnableToContactSuccessSub$()];
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((s) => s.unsubscribe());
  }

  onSubmit($event: any) {
    if (this.isSubmitLoading() || !$event?.surgeryUnableToContactForm) return;

    let surgeryUnableToContactBind = {
      surgeryID: this.surgery?.id ?? '',
      surgeryCommunicationFailedComments:
        $event?.surgeryUnableToContactForm.unableToContactComments,
    };

    this.surgeryPrivateService
      .communicationFailedSurgery(surgeryUnableToContactBind)
      .subscribe();
  }

  onSubmitSuccess(): void {
    this.surgeryPrivateService.init();
    this.visible = false;
    this.showSuccessMessage();
    this.success.emit();
  }

  showSuccessMessage(): void {
    this.coreService.showSuccess(
      'Η αλλαγή σε "Αδυναμία Επικοινωνίας" ολοκληρώθηκε με επιτυχία'
    );
  }

  close(): void {
    this.visible = false;
    this.unableToContactComments = '';
    this.messages = [];
  }

  getHeader(): string {
    return 'Αδυναμία Επικοινωνίας';
  }

  getFormConfig() {
    return this.formConfig;
  }

  setFormControlValue(formControlName: string, value: any) {
    return this.eoForm?.setValue(
      'surgeryUnableToContactForm',
      formControlName,
      value
    );
  }

  initForm() {
    this.eoForm?.form.reset();
    this.eoForm?.form.enable();

    if (this.surgery) {
    }
  }

  getSurgeryUnableToContactSuccessSub$() {
    return this.surgeryPrivateService.surgeryCommunicationFailedCallHandler.status$
      .pipe(filter((s) => s === STATUS.success))
      .subscribe(() => {
        this.onSubmitSuccess();
      });
  }

  isSubmitLoading(): boolean {
    const sStatus =
      this.surgeryPrivateService.surgeryCommunicationFailedCallHandler?.status$?.getValue();
    return sStatus === STATUS.loading;
  }

  show(surgery: Surgery): void {
    this.surgery = surgery;
    this.initForm();
    this.visible = true;
    this.messages = [
      {
        severity: 'error',
        detail:
          'Προσοχή! Είστε σίγουροι ότι θέλετε να δηλώσετε «Αδυναμία Επικοινωνίας»; Η επιλογή αυτή γίνεται από τον χρήστη του νοσοκομείου σύμφωνα με τα οριζόμενα του Άρθρου  7 Όροι-Προϋποθέσεις-Προγραμματισμός-Οργάνωση και Συμμετοχή στα Απογευματινά Χειρουργεία στα Νοσοκομεία, της Γ2α/οικ.60739 ΚΥΑ (ΦΕΚ Β, 6520-27/11/2024).',
      },
    ];
  }
}
